import React, { useState } from 'react'

import { Flex } from 'lese'
import { Button } from 'Components/shared/Button'
import Input from 'Components/shared/Input'

import { ModalCard, closeModal } from 'components/Modal'
import { SelectIcon } from 'Components/shared/Select'
import { icons } from 'Constants'
import { useInput } from 'Helpers/'
import { toast } from 'react-toastify'
import CustomLinkService from 'Services/customlinks'
import { toastWithErrorMessage } from 'Helpers/toast'

const EditLinkModal = ({ customLink, customLinks, updateLinks, onCancel = closeModal }) => {
  const shortNameHook = useInput(customLink.shortname)
  const longNameHook = useInput(customLink.longname)
  const urlHook = useInput(customLink.url)
  const [icon, setIcon] = useState(customLink.icon)

  const updateCustomLink = async () => {
    if (!shortNameHook.value || !longNameHook.value || !urlHook.value) {
      toast.error('Please provide all the fields for the custom link.')
      return
    }

    const data = {
      icon: parseInt(icon, 10),
      shortname: shortNameHook.value,
      longname: longNameHook.value,
      url: urlHook.value,
      deleted: 0
    }

    await CustomLinkService.update({ id: customLink.id, data })
      .then(async () => {
        const clIds = customLinks.map(link => link.id)
        await updateLinks({ ids: clIds })
        onCancel()
      })
      .catch(error => toastWithErrorMessage(error.message))
  }

  return (
    <ModalCard>
      <Flex separation="24px" padding="2em">
        <SelectIcon
          onChange={e => {
            setIcon(e.newIndex)
          }}
          options={icons}
          defaultIndex={icon}
          height="15vh"
        />
        <Input placeholder="Name" {...shortNameHook.bind} /> {/* Name */}
        <Input placeholder="Description" {...longNameHook.bind} /> {/* Description */}
        <Input placeholder="Link" {...urlHook.bind} /> {/* URL */}
        <Button
          onClick={() => {
            updateCustomLink()
          }}
        >
          Update
        </Button>
      </Flex>
    </ModalCard>
  )
}

const EditNewLinkModal = ({ customLink, customLinks, setCustomLinks, onCancel = closeModal }) => {
  const shortNameHook = useInput(customLink.shortName)
  const longNameHook = useInput(customLink.longName)
  const urlHook = useInput(customLink.url)
  const [icon, setIcon] = useState(customLink.icon)

  const updateCustomLink = async () => {
    if (!shortNameHook.value || !longNameHook.value || !urlHook.value) {
      toast.error('Please provide all the fields for the custom link.')
      return
    }

    const data = {
      icon: parseInt(icon, 10),
      shortName: shortNameHook.value,
      longName: longNameHook.value,
      url: urlHook.value,
      deleted: 1
    }

    customLinks.splice(customLinks.indexOf(customLink), 1)
    customLinks.push(data)
    setCustomLinks([...customLinks])
    onCancel()
  }

  return (
    <ModalCard>
      <Flex separation="24px" padding="2em">
        <SelectIcon
          onChange={e => {
            setIcon(e.newIndex)
          }}
          options={icons}
          defaultIndex={icon}
          height="15vh"
        />
        <Input placeholder="Name" {...shortNameHook.bind} /> {/* Name */}
        <Input placeholder="Description" {...longNameHook.bind} /> {/* Description */}
        <Input placeholder="Link" {...urlHook.bind} /> {/* URL */}
        <Button
          onClick={() => {
            updateCustomLink()
          }}
        >
          Update
        </Button>
      </Flex>
    </ModalCard>
  )
}

export { EditLinkModal, EditNewLinkModal }
